import { defineMessages } from 'react-intl';

export default defineMessages({
  cardTitle: {
    id: 'homeSignatureAreaCard.cardTitle',
    defaultMessage: 'Area firma',
  },
  descriptionSignatureAreaCardFirstPart: {
    id: 'homeSignatureAreaCard.descriptionSignatureAreaCardFirstPart',
    defaultMessage: 'Hai',
  },
  descriptionSignatureAreaCardSecondPart: {
    id: 'homeSignatureAreaCard.descriptionSignatureAreaCardSecondPart',
    defaultMessage: 'pratiche da firmare',
  },
  buttonLabelSignatureAreaCard: {
    id: 'homeSignatureAreaCard.buttonLabelSignatureAreaCard',
    defaultMessage: 'Visualizza',
  },
  descriptionSignatureAreaCardNoDocuments: {
    id: 'homeSignatureAreaCard.descriptionSignatureAreaCardNoDocuments',
    defaultMessage: 'Non sono presenti pratiche da firmare',
  },
});
